export default __webpack_public_path__ + "static/media/mm_icon.72fc9f65.png";